module.exports = __webpack_public_path__ + "static/media/Benchmarking.cae1ee85.pdf";